import React from 'react';
import styled from 'styled-components';
import { cms } from 'assets/cms';

const ImagesWrapper = styled.div`
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  img {
    height: auto;
    width: 100%;
    margin: 2px;
    opacity: 0.8;
    transition: all 0.2s ease-in-out;
    @media ${({ theme }) => theme.media.tablet} {
      width: 40%;
      height: auto;
    }
    @media ${({ theme }) => theme.media.laptop} {
      width: 23%;
    }

    &:hover {
      transform: scale(1.2);
      opacity: 1;
      z-index: 999;
    }
  }
`;

const FarmGallery = () => (
  <>
    <ImagesWrapper>
      <img src={cms.images.farm1} />
      <img src={cms.images.farm2} />
      <img src={cms.images.farm4} />
      <img src={cms.images.farm5} />
      <img src={cms.images.farm6} />
      <img src={cms.images.farm7} />
      <img src={cms.images.farm8} />
      <img src={cms.images.farm9} />
    </ImagesWrapper>
  </>
);

export default FarmGallery;
